import * as util from './util.js'

// var mockCookieJson = '{"privacy": "", "required": {"required": true, "links": ["https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js","https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"]},"marketing": {"required": false, "links": ["https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js","https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"]}}'
export default (id) => {
  const currentScript = util.getCurrentScript(id)

  return {
    SERVER_URL: currentScript && currentScript.getAttribute('data-url') ? currentScript.getAttribute('data-url') : 'http://localhost:8000',
    ORIGIN_KEY: currentScript && currentScript.getAttribute('data-originkey') ? currentScript.getAttribute('data-originkey') : 'hafasamband',
    TOKEN_ATTR: currentScript && currentScript.getAttribute('data-token') ? currentScript.getAttribute('data-token') : false,
    LANGUAGE_CODE: currentScript && currentScript.getAttribute('data-lang') ? currentScript.getAttribute('data-lang') : 'is',
    STEP4_REDIRECT_URL: currentScript && currentScript.getAttribute('data-redirect') ? currentScript.getAttribute('data-redirect') : '',
    COOKIE_INFO: currentScript && currentScript.getAttribute('data-cookie') ? currentScript.getAttribute('data-cookie') : '',
    COOKIE_VERSION: currentScript && currentScript.getAttribute('data-cookieversion') ? currentScript.getAttribute('data-cookieversion') : '0',
    WEB_COOKIE_PAGE_LINK: currentScript && currentScript.getAttribute('data-cookie-link') ? currentScript.getAttribute('data-cookie-link') : 'https://www.or.is/um-or/skipulag-og-stjornhaettir/stefnuskjol/vafrakokur/',
    DISPLAY_MODE: currentScript && currentScript.getAttribute('data-displaymode') ? currentScript.getAttribute('data-displaymode') : 'default',
    ALERTS: {
      INVALID_FIELDS: 'Einhverjir reitir eru ekki rétt útfylltir \n\n',
      EMPTY_FIELDS: 'Vantar að fylla út nauðsynlega reiti \n\n',
      INVALID_RANGE: 'Einn eða fleiri álestrar utan viðmiðunarmarka. Athugið hvort rétt gildi hafi verið slegið inn\n\n',
      INVALID_DATE: '',
      INSTRUCTIONS: 'Ýttu á OK til að halda áfram eða Cancel til að hætta við',
      NO_METERS_SELECTED: 'Engir mælar valdir',
      INVALID_PAYMENT_INFO: 'Veldu greiðslumáta',
      INVALID_CREDIT_CARD_INFO: 'Vinsamlegast fylltu út kortaupplýsingar',
      INVALID_CREDIT_CARD_EXPIRATION_DATE: 'Athugaðu hvort gildistími kreditkorts sé réttur',
      INVALID_AGE: 'Lágmarksaldur til að taka við mælum er 18 ár'
    },
    REPORTER: {
      'movingout': 0,
      'movingin': 1,
      'annar': 2
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/constants.js